<template>
<div>
    <div v-if="showLogin">
        <div class="login-container">
            <div class="choose">
                <div v-if="telLogin">
                    <h1>手机号登录</h1>
                    <input class="logininput" type="text" placeholder="输入手机号码" v-model="tel" />
					<input class="logininput" type="text" placeholder="输入计算结果" v-model="imgCodeVal" />
					<div class="yzm"><img v-bind:src="imgCode" class="imgCode" @click="getImgCode" ></div>
                    <input class="logininput" type="text" placeholder="验证码" v-model="code" />
                    <div class="yzm"><span v-show="show" @click="sendCode">获取验证码</span> <span v-show="!show" class="yzm">{{count}} s</span></div>
                    <button class="login-btn" @click="loginBtnClick">登录</button>
                    <div class="jihuoma" @click="telLogin=false">激活码登录</div>
                </div>
                <div v-else>
                    <h1>激活码登录</h1>
                    <input class="logininput" type="text" placeholder="输入手机号码" v-model="tel" />
                    <input class="logininput" type="text" placeholder="输入激活码" v-model="invitationCode" />
                    <button class="login-btn" @click="jihuoBtnClick">使用激活码</button>
                    <div class="jihuoma" @click="telLogin=true">手机号登录</div>
                </div>
                <div class="err">{{errMsg}}</div>

            </div>

        </div>
        <div class="blackbg" @click="$store.commit('showLogin')"></div>
    </div>
    <!-- <div v-if="showVipQrcode">
        <div class="login-container">
            <div class="choose">
                <h1>请用微信扫码订阅</h1>
                <p><img src="../assets/buyvipqrcode.png" width="220" /></p>
            </div>

        </div>
        <div class="blackbg" @click="$store.commit('showVipQrcode')"></div>
    </div>
    <div v-if="showFreeVip">
        <div class="login-container">
            <div class="choose">
                <h1>微信扫码领取7天体验VIP</h1>
                <p><img src="../assets/freevipqrcode.png" width="220" /></p>
            </div>

        </div>
        <div class="blackbg" @click="$store.commit('showFreeVip')"></div>
        
    </div> -->
</div>
</template>

<style>
.blackbg {
    background: black;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0.6;
    z-index: 100;
}

.login-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 1000;
    text-align: center;
}

.login-container h1 {
    padding-top: 60px;
    padding-bottom: 10px;
    font-size: 28px;
    font-family: Source Han Serif CN;
    font-weight: 600;
    color: #242A26;
}

.login-container .choose {
    width: 27rem;
    height: 25rem;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 0 5px #aaa;
}

.choose span {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: #f1f1f1;
    cursor: pointer;
}

.choose span:hover {
    color: #fff;
}

.btn-box {
    position: relative;
    height: 26rem;

}

.btn-box>div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}

.login-btn {
    display: inline-block;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    margin-top: 20px;
    width: 290px;
    height: 46px;
    line-height: 46px;
    background: #06CA9A;
    border-radius: 4px;
    color: #ffffff;
    cursor: pointer;
    border: 1px;
}

.login-btn:hover {
    background-color: #2c3e50;
}

.logininput {
    width: 250px;
    height: 40px;
    background: #F7F9F8;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #242A27;
    outline: none;
    border: 0;
    padding: 0 20px;
    margin-bottom: 3px;
}

input::-webkit-input-placeholder {
    font-weight: 400;
    color: #9CA6A6;

}

.err {
    padding: 10px 0;
    color: #ff0000
}

.yzm {
    position: relative
}

.yzm span {
    position: absolute;
    top: -24px;
    right: 80px;
    width: 103px;
    height: 32px;
    line-height: 30px;
    background: #def4ee;
    border-radius: 16px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #06CA9A;
}

.yzm span:hover {
    background: #06CA9A;
    color: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .1s;
}

.fade-enter,
.fade-leave-active {
    opacity: 0
}

.jihuoma {
    text-align: center;
    padding-top: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #9BA6A6;
    cursor: pointer;
}

.jihuoma:hover {
    color: black;
}
.imgCode{
	position: absolute;
	top: -43px; 
	right: 72px;
	height: 40px;
}
</style>

<script>
import {
    setCookie,getCookie
} from '@/network/cookie'
export default {
    name: 'login',
    data() {
        return {
            tel: '',
            code: '',
            invitationCode:'',
            show: true,
            count: '',
            timer: null,
            errMsg: '',
            telLogin: true,
			imgCode: '',
			key: '',
			imgCodeVal: '',
        }
    },
    computed: {
        showLogin() {
            return this.$store.state.showLogin
        },
        showVipQrcode() {
            return this.$store.state.showVipQrcode
        },
        showFreeVip(){
            return this.$store.state.showFreeVip
        }

    },
    methods: {
        showMsg: function (msg) {
            if (msg) {
                this.errMsg = msg;
                var that = this;
                setTimeout(function () {
                    that.errMsg = '';
                }, 3000)
            }
        },
        loginBtnClick: function () {
            if (this.tel && this.code) {
                this.$http.get({
                    url: 'xcx/code-login?tel=' + this.tel + '&code=' + this.code
                }).then(res => {
                    this.showMsg(res.data.meta.message);
                    setCookie('sessionId', res.data.data.sessionId);
                    this.$store.commit('showLogin');
                    this.getUserInfo(res.data.data.sessionId);
                    //this.$store.state.userInfo = res.data.data;
                })
            } else {
                this.showMsg('请输入手机号和验证码')
            }
        },
        jihuoBtnClick: function () {
            if (this.tel && this.invitationCode) {
                this.$http.get({
                    url: '/xcx/vip-code-login?tel=' + this.tel + '&invitationCode=' + this.invitationCode
                }).then(res => {
                    this.showMsg(res.data.meta.message);
                    setCookie('sessionId', res.data.data.sessionId);
                    this.$store.commit('showLogin');
                    this.getUserInfo(res.data.data.sessionId);
                    //this.$store.state.userInfo = res.data.data;
                })
            } else {
                this.showMsg('请输入手机号和验证码')
            }
        },
        getUserInfo:function(s){
            var cookies = '';
            if(s){
                cookies = s
            }else{
                cookies = getCookie('sessionId')
            }
            this.$http.get({url:'xcx/user-info?sessionId='+cookies}).then(res=>{
            this.$store.commit('updateUserInfo',res.data.data);
      })
        },
        sendCode: function () {
            this.$http.get({
                url: 'xcx/code?tel=' + this.tel + '&key=' +this.key + '&code=' + this.imgCodeVal
            }).then(res => {
                if (res.data.meta.success) {
                    this.getCode();
                } else {
                    this.showMsg(res.data.meta.message)
                }
            })
        },
        getCode() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }

        },
		// 获取验证码
		getImgCode: function () {
           this.$http.get({
               url: '/xcx/captcha2!key'
           }).then(res => { 
			this.key = res.data.data
            this.imgCode = 'https://apis.auto-learning.com/v3/xcx/captcha2?key=' + res.data.data
           })
        }, 
    },
    mounted(){
		this.getImgCode()
        if(getCookie('sessionId')){
            this.telLogin = false
        }
    }
}
</script>
